import { Box } from '@mui/material';

export default function ItemDetail({ children }) {
    return (
        <Box sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            pl: 0.5,
        }}>
            {children}
        </Box>
    );
}